import styled from 'styled-components';

export const BoxTextPackTracking = styled.p`
  margin: 0 0 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BoxGridParts = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  align-items: center;

  p {
    margin: 0;
  }
`;

export const ContentListsPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ContainerButton = styled.div`
  display: flex;
  gap: 50px;
`;

export const TextButtonOpen = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  color: ${({ theme }) => theme.pantone2726C};
  margin-top: 1rem;
  padding: 0.5rem 0;
`;

export const Content = styled.div`
  position: relative;
  margin-bottom: 10px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: -20px;
    width: calc(100% + 40px);
    height: 1px;
    background-color: ${({ theme }) => theme.pantone642C};
  }
`;
export const CountParts = styled.span`
  display: inline-block;
  border: 1px solid ${({ theme }) => theme.pantone2726C};
  border-radius: 5px;
  padding: 0px 15px;
  margin-top: 5px;
`;
export const TextDevolution = styled.h5`
  color: ${({ theme }) => theme.red};
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 0.7rem;
`;

export const ImagePartComponent = styled.div`
  > img {
    width: 100%;
    max-width: 200px;
    max-height: 200px;
    min-width: 200px;
    min-height: 200px;
    object-fit: contain;
  }
`;

export const HyperLink = styled.a`
  &&& {
    color: ${({ theme }) => theme.pantone2727C};
    text-decoration: underline;
  }
`;

export const ContainerQuantityWithPart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .partName{
    width: 100%;
    max-width: 200px;
  }
`;